import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';
import { PurchaseOrderHeaderStatus } from '../../purchase-order-header-statuses/purchase-order-header-status.model';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { FilterDescriptor } from 'devextreme/data';
import { PurchaseOrderHeaderStatusesService } from '../../purchase-order-header-statuses/purchase-order-header-statuses.service';

@Component({
  selector: 'app-purchase-order-status-select-modal',
  templateUrl: './purchase-order-status-select-modal.component.html',
  styleUrls: ['./purchase-order-status-select-modal.component.scss']
})
export class PurchaseOrderStatusSelectModalComponent extends BaseModalComponent<PurchaseOrderHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select order status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public purchaseOrderHeaderStatusesService: PurchaseOrderHeaderStatusesService) {
    super();
  }

}